import { useStrictLocalization } from "@faire/localization/react/useStrictLocalization";
import { Close as CloseIcon } from "@faire/slate-icons/Close";
import { FormFieldIconButton } from "@faire/slate/private/form/FormFieldIconButton";
import React from "react";

type IProps = {
  label?: string;
  onClick?: (e: React.MouseEvent) => void;
};

export const ClearButton: React.FC<IProps> = ({ label, onClick }) => {
  const { strictLocalize } = useStrictLocalization();
  return (
    <FormFieldIconButton
      Icon={CloseIcon}
      onClick={onClick}
      // NOTE: needed to prevent input blur (collapsed Search input stays open on close button click)
      onMouseDown={(e) => e.preventDefault()}
      aria-label={
        label ??
        strictLocalize({
          id: "3JICzw",
          defaultMessage: "Clear search",
          description: {
            text: "Label for button to clear the search input",
          },
        })
      }
    />
  );
};
